import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class PaymentTypeComponent implements OnInit {
  defaultOption = 'bankTransfer'

  @Input('form') form:FormGroup;
  paymentType:FormControl;
  ngOnInit(): void {
    this.paymentType = this.form.get('paymentType') as FormControl;
  }
}
